import { doubleDecisionConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...doubleDecisionConfig,
    // MVP : on coupe maxTrials à 24 pour rester < 3 min (test live, pas convergence sérieuse).
    maxTrials: 24,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            nDistractors: 1,
            eccentricity: '10deg',
            movingDistractors: false,
            drivingSkin: false,
            label: 'Découverte du champ',
        };
    }
    if (level <= 20) {
        return {
            level,
            nDistractors: 3,
            eccentricity: '20deg',
            movingDistractors: false,
            drivingSkin: false,
            label: 'Filtrage actif',
        };
    }
    if (level <= 30) {
        return {
            level,
            nDistractors: 5,
            eccentricity: '30deg',
            movingDistractors: false,
            drivingSkin: false,
            label: 'Limite UFOV',
        };
    }
    if (level <= 40) {
        return {
            level,
            nDistractors: 5,
            eccentricity: '30deg',
            movingDistractors: true,
            drivingSkin: false,
            label: 'Capture exogène',
        };
    }
    return {
        level,
        nDistractors: 5,
        eccentricity: '30deg',
        movingDistractors: true,
        drivingSkin: true,
        label: 'Conduite augmentée',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** 8 positions périphériques (cardinales + diagonales), en degrés horaire depuis le haut. */
export const PERIPHERAL_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];
/** Rayon de la couronne stimulus (px), grossi avec eccentricity bucket. */
export const eccentricityRadiusPx = {
    '10deg': 90,
    '20deg': 130,
    '30deg': 160,
};
/** Durées non-staircase (fixation, mask, ITI). */
export const timing = {
    fixationMs: 500,
    maskMs: 200,
    itiMs: 700,
    // Floor sécurité : si staircase descend en-dessous, on cap rendu à 16ms (1 frame @60Hz).
    minRenderMs: 16,
};
/** Cibles centrales — 2 catégories. MVP : icônes véhicule. */
export const CENTRAL_CHOICES = ['A', 'B'];
export const CENTRAL_LABELS = {
    A: '🚗',
    B: '🚙',
};
export const paradigmMeta = {
    slug: 'double-decision',
    paradigm: 'UFOV-3 (Useful Field Of View, sub-test 3)',
    masterMage: 'Embra (vivacité-feu) + Inori (attention-air)',
    category: 'air_attention',
    goal: 'Conduire, marcher en ville, sport — vision périphérique sous distracteurs.',
};
//# sourceMappingURL=params.js.map